import Vue from 'vue'
import Vuex from 'vuex'

import commonPlugin from './commonPlugin.js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    app,
  },
  plugins: [commonPlugin]
})
